var React = require('react');

function AsteriskInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 3.92593L5.32476 6L0.0385852 8.07407L1.15756 9.96296L5.67203 6.55556L4.90032 12H7.09968L6.32797 6.55556L10.8424 9.96296L12 8.07407L6.67524 6L11.9614 3.92593L10.8424 2.07407L6.32797 5.44444L7.09968 0H4.90032L5.67203 5.44444L1.15756 2.07407L0 3.92593Z","fill":"black"}));
}

AsteriskInline.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none"};

module.exports = AsteriskInline;

AsteriskInline.default = AsteriskInline;
